import styled from '@emotion/styled';
import './App.css';
import { Maze } from './components/Maze';
import { STORAGE_KEY } from './constants';
import { lossGrid } from './Grids';
import logo from './logo.jpg';
import { initEmptyArrayAtKey } from './utils';
function App() {
  const Container = styled.div`
  padding: 50px;
`

  return (
    <Container>
      <p><img  style={{display: "block" ,marginLeft: 'auto',marginRight:'auto'} }src={logo}></img></p>
      <Maze grid={lossGrid}/>
      <div>
        <h2>What is Proof Of Engagement?</h2>
        <p>
          We here at Eyedol games believe that YOU are your own best advocate! Do the things YOU enjoy and in exchange you will earn TOKENS to make progress through our LossPass system to get the content you crave in a fair and timely fashion!
        </p>
        <p>
          CrypticCurrency thrives on YOUR obsessions, after all!  Can you get to the end of the maze before your friends?
        </p>
        <p>If you find yourself hopelessly lost, feel free to <button onClick={()=>{
          initEmptyArrayAtKey(STORAGE_KEY)
          window.location.href = window.location.href;
          }}>Clear Your Progress</button>.</p>
      </div>
    </Container>
  );
}

export default App;
